import React from 'react';

interface CustomIconProps {
  filled?: boolean;
  color?: string;
  width?: string;
}

const CourseLanguageIcon: React.FC<CustomIconProps> = () => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='bxs-square'>
      <path
        id='Subtract'
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 3H20C20.2652 3 20.5196 3.10536 20.7071 3.29289C20.8946 3.48043 21 3.73478 21 4V20C21 20.2652 20.8946 20.5196 20.7071 20.7071C20.5196 20.8946 20.2652 21 20 21H4C3.73478 21 3.48043 20.8946 3.29289 20.7071C3.10536 20.5196 3 20.2652 3 20V4C3 3.73478 3.10536 3.48043 3.29289 3.29289C3.48043 3.10536 3.73478 3 4 3ZM12.9041 6.90388V5.0957H11.0959V6.90388H5.67137V8.71206L14.6309 8.71296C14.0209 10.3261 13.1302 11.8186 12 13.1213C11.3063 12.3226 10.702 11.4504 10.1981 10.5202H8.17299C8.83394 11.9318 9.69339 13.2415 10.7252 14.4096C9.33115 15.6549 7.69006 16.592 5.90915 17.1599L6.39374 18.9039C8.47228 18.2522 10.3849 17.1578 12 15.6962C12.8296 16.4438 13.7381 17.0989 14.7096 17.6499L15.3885 15.952C14.636 15.5075 13.9287 14.9906 13.2766 14.4087C14.7389 12.7488 15.852 10.8114 16.5494 8.71206H18.3286V6.90388H12.9041Z'
        fill='white'
      />
    </g>
  </svg>
);

export default CourseLanguageIcon;
